import { DatePicker } from '@storeblocks/datepicker';
import { useField, useFormikContext } from 'formik';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { useUserDateFnsLocale, useUserLocale } from '@/i18n/hooks';
import { nameof } from '@/util/nameof';

import { DepositOrderFormValues } from '../types/DepositOrderFormValues';
import { expectedDepositDate } from '../utils/expectedDepositDate';

export const ExpectedDepositDateSelector: FC = () => {
  const texts = useTexts();
  const locale = useUserLocale();
  const dateFnsLocale = useUserDateFnsLocale();

  const [field, meta, helpers] = useField<
    DepositOrderFormValues['expectedDepositDate']
  >(nameof<DepositOrderFormValues>('expectedDepositDate'));

  const { submitCount } = useFormikContext<DepositOrderFormValues>();

  return (
    <DatePicker
      {...field}
      id="expected-deposit-date"
      locale={locale}
      format={expectedDepositDate.dateFormat(dateFnsLocale)}
      min={expectedDepositDate.minimumDate()}
      aria-label={texts.orders.form.depositDate.title}
      labelText={texts.orders.form.depositDate.title}
      selectMonthAriaLabel={texts.datepicker.selectMonthAriaLabel}
      selectYearAriaLabel={texts.datepicker.selectYearAriaLabel}
      hintText={texts.orders.form.depositDate.description}
      // Must also use submit count otherwise the validation error
      // is displayed when the user clicks on the calendar icon.
      alertMessageType={
        submitCount > 0 && meta.touched && meta.error ? 'error' : undefined
      }
      alertMessage={meta.error}
      // Override the 'onChange' and 'onBlur' as per
      // the Storeblocks documentation.
      onChange={(_, selectedDate) => {
        helpers.setValue(selectedDate.date);
      }}
      onBlur={() => {
        helpers.setTouched(true);
      }}
      size="fluid"
    />
  );
};
